import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.07192 8.07192C5.58449 7.55936 6.41551 7.55936 6.92808 8.07192L12 13.1438L17.0719 8.07192C17.5845 7.55936 18.4155 7.55936 18.9281 8.07192C19.4406 8.58449 19.4406 9.41551 18.9281 9.92808L12.9281 15.9281C12.6819 16.1742 12.3481 16.3125 12 16.3125C11.6519 16.3125 11.3181 16.1742 11.0719 15.9281L5.07192 9.92808C4.55936 9.41551 4.55936 8.58449 5.07192 8.07192Z'
            />
        </SvgIcon>
    );
});
